import React, { useState } from "react";

import PropTypes from "prop-types";

import { Label } from "rbx";
import { uuidGenerator } from "../../../utils";

import DirectionsInputRow from "./DirectionsInputRow";

import "./DirectionsInput.scss";

import { parseDirections } from "./utils";

const DirectionsInput = ({ name = "Directions", value = "", onChange }) => {
  const [directions, setDirections] = useState(() => parseDirections(value));

  const getFormattedDirections = (currDirections = []) => {
    const maxTextLength = Math.max(...currDirections.map(d => d.text.length));
    return currDirections
      .map(d => `${d.text.padEnd(maxTextLength, " ")} ${d.miles} MILES`)
      .join("\n");
  };

  const doUpdate = (d = directions) => {
    const formattedDirections = getFormattedDirections([...d]);
    onChange({ target: { name, value: formattedDirections } });
  };

  const removeRow = index => () => {
    const currDirections = [...directions];
    currDirections.splice(index, 1);
    setDirections(currDirections);
    doUpdate(currDirections);
  };

  const insertAfter = index => () => {
    const currDirections = [...directions];
    currDirections.splice(index + 1, 0, {
      miles: 0,
      text: "",
      id: uuidGenerator()
    });
    setDirections(currDirections);
  };

  const handleChange = index => e => {
    const currDirections = [...directions];
    currDirections[index][e.target.name] = e.target.value;
    setDirections(currDirections);
  };

  const handleBlur = () => {
    doUpdate();
  };

  const totalMiles = directions.reduce((a, c) => a + parseFloat(c.miles), 0);

  return (
    <div>
      <div className="directions-input-header">
        <div />
        <div>
          <Label>Directions</Label>
        </div>
        <div>
          <Label>Miles</Label>
        </div>
        <div />
      </div>
      {directions.map((dir, i) => (
        <DirectionsInputRow
          direction={dir}
          handleBlur={handleBlur}
          handleChange={handleChange(i)}
          insertAfter={insertAfter(i)}
          key={`dir-${dir.id}`}
          removeRow={removeRow(i)}
        />
      ))}

      <DirectionsInputRow
        disabled
        direction={{ text: "Total", miles: totalMiles.toFixed(2) }}
      />
    </div>
  );
};

DirectionsInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};
export default DirectionsInput;
